import React from "react";

export const createHTMLMarkup = (text) => { return {__html: text}; };



// WEBPACK FOOTER //
// ./src/utils/HTML.js